import React from "react";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { Switch } from "@/components/ui/switch";

export function BillingEnabledRow({
  checked,
  disabled,
  onChange,
}: {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}) {
  const { t } = useTranslation();

  const id = "billing-enabled";
  return (
    <div className="border-base-border bg-secondary-badge flex min-h-24 items-center justify-between gap-4 rounded-lg border p-4">
      <div className="flex flex-col gap-1">
        <Label htmlFor={id} className="text-sm text-black/96">
          {t("billing.enabled")}
        </Label>
        <p className="text-xs leading-5 text-black/55">
          {t("billing.enabledDescription")}
        </p>
      </div>
      <Switch
        id={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={onChange}
      />
    </div>
  );
}
